import type { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';

/**
 * BOXY-612 — the query cache belongs to ONE signed-in account.
 *
 * Keys like `['service-preferences', lang]` or `['order-count']` name no
 * account, and sign-out only dropped `['user']`. So the next merchant to sign
 * in, in the same tab, read the previous one's saved service (5-minute stale
 * window) and the create form skipped Select Service on a choice they never
 * made. Any token change — sign-in, sign-out, workspace switch, a 401 — empties
 * the cache, so every answer is fetched for the account that now holds it.
 */
export const bindQueryCacheToAccount = (queryClient: QueryClient) =>
  useAuthStore.subscribe((state, previous) => {
    if (state.token !== previous.token) queryClient.clear();
  });
